import { CONFIG } from '../data/config';

/** Seasons are derived purely from the day counter — no save field needed. */
export type SeasonId = 'spring' | 'summer' | 'fall' | 'winter';

export interface Season {
  id: SeasonId;
  name: string;
  index: number;
  /** Ambient multiply tint for the season. */
  tint: number;
}

const SEASONS: Season[] = [
  { id: 'spring', name: 'Spring', index: 0, tint: 0xd6f0c8 },
  { id: 'summer', name: 'Summer', index: 1, tint: 0xfff2c4 },
  { id: 'fall', name: 'Fall', index: 2, tint: 0xf2c890 },
  { id: 'winter', name: 'Winter', index: 3, tint: 0xd6e6f4 },
];

export function seasonOf(day: number): Season {
  const i = Math.floor((Math.max(1, day) - 1) / CONFIG.daysPerSeason) % SEASONS.length;
  return SEASONS[i]!;
}

export function dayOfSeason(day: number): number {
  return ((Math.max(1, day) - 1) % CONFIG.daysPerSeason) + 1;
}

export function yearOf(day: number): number {
  return Math.floor((Math.max(1, day) - 1) / (CONFIG.daysPerSeason * SEASONS.length)) + 1;
}

/** The mid-season fair day (6th day of each season) — a little festival. */
export function isFestivalDay(day: number): boolean {
  return dayOfSeason(day) === 6;
}
export function festivalName(day: number): string {
  return `${seasonOf(day).name} Fair`;
}
